import { isFollowUpEmailType } from "../shared/enums";

export const SENDER_FROM_PREVIOUS = "previous";
export const SENDER_FROM_POOL = "pool";

export const isReadySender = (account) => !!(account && account.email && account.password);

export const usesPreviousSender = (step, templateType) => {
  if (!step) return false;
  if (step.senderFrom === SENDER_FROM_POOL) return false;
  if (step.senderFrom === SENDER_FROM_PREVIOUS) return true;
  return isFollowUpEmailType(templateType);
};

export const normalizeSenderAccountIds = (raw) => {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const ids = [...new Set(raw.filter((id) => typeof id === "string" && id.trim()))];
  return ids.length ? ids : null;
};

export const toggleSenderAccountId = (current, id) => {
  const ids = normalizeSenderAccountIds(current) || [];
  if (ids.includes(id)) {
    return ids.filter((x) => x !== id);
  }
  return [...ids, id];
};

export const senderPoolLabel = (step, accounts = [], templateType) => {
  if (usesPreviousSender(step, templateType)) return "From previous account";
  const ready = accounts.filter(isReadySender);
  const ids = normalizeSenderAccountIds(step && step.senderAccountIds);
  if (!ids) {
    return ready.length <= 1
      ? (ready[0]?.email || "All that work")
      : `All that work (${ready.length})`;
  }
  const picked = ready.filter((a) => ids.includes(a.id));
  if (picked.length === 0) return "No working sender";
  if (picked.length === 1) return picked[0].email;
  return `${picked.length} senders`;
};
